import { DeltaArrow } from '@plato/ui-legacy/components/typography/delta-arrow';
import { PercentageOrEmpty } from '@plato/ui-legacy/components/typography/percentage-or-empty';
import { cn } from '@plato/ui/util/classes';

type PercentageDeltaBadgeProps = {
    children: number | undefined | null;
};

export function PercentageDeltaBadge({ children }: PercentageDeltaBadgeProps) {
    const isPositive = children && children > 0 ? true : children && children < 0 ? false : null;

    return (
        <div
            className={cn(
                'flex shrink-0 flex-row items-center justify-center rounded-md px-[6px] py-[5px] text-sm font-semibold',
                isPositive === true && 'bg-green-50 text-green-600',
                isPositive === false && 'bg-red-50 text-red-600',
                isPositive === null && 'bg-neutral-50 text-neutral-600',
            )}
        >
            <PercentageOrEmpty showPlusSignIfPositive decimals={0}>
                {children}
            </PercentageOrEmpty>
            <DeltaArrow up={isPositive} className="ml-0.5" />
        </div>
    );
}
